import axios from "axios";
import jwt_decode from "jwt-decode";
import { useSelector, useDispatch } from "react-redux";
import { uiActions } from "../store/ui-slice";

axios.defaults.headers.post["Content-Type"] = "application/json";

const SetupAxios = (props) => {
	const dispatch = useDispatch();

	const apiConfigData = useSelector((state) => state.apiConfigData);

	axios.interceptors.request.use(
		async function (config) {
			const tokenString =
				typeof config.token === "object"
					? config.token.token
					: config.token;

			// console.log("***** SETUP AXIOS TOKEN *****", tokenString);

			let newConfig;

			if (is_token_expired(tokenString)) {
				console.log("token is expired");
				// newConfig = await getNewToken(config);

				// const newStoreToken = {
				// 	jwtToken: newConfig.token,
				// 	refreshToken: newConfig.refreshToken
				// }
				// dispatch(uiActions.updateToken(newStoreToken));
			} else {
				// console.log("token is ok");
				newConfig = config;
			}

			// console.log("RETURN 2", newConfig);
			newConfig.headers["Authorization"] = "Bearer " + tokenString;
			return newConfig;
		},
		function (error) {
			return Promise.reject(error);
		}
	);

	axios.interceptors.response.use(
		function (response) {
			return response;
		},
		function (error) {
			return error.response.data;
		}
	);

	const getNewToken = async (config) => {
		// console.log("CONFIG", config)

		const tokenObject = JSON.stringify({
			jwtToken: config.token.token,
			refreshToken: config.token.refreshToken,
		})

		let newConfig;
		
		// await fetch("https://dev-api-inefop.mylearningroute.com/api/auth/Account/refresh-token", {
		await fetch(apiConfigData.endpoint.domain + apiConfigData.endpoint.refreshToken, {
			method: "POST",
			headers: {
				'Content-Type': 'application/json'
			},
			body: tokenObject,
		})
			.then((response) => response.json())
			.then((json) => {
				// console.log("AAAAAAAAAAAAAAAAAA ", json);
				newConfig = {...config, token: json.jwtToken, refreshToken: json.refreshToken}
			});
		
		// const newConfig = {...config, token: json.jwtToken, refreshToken: json.refreshToken}
		// console.log("RETURN 1", newConfig);
		return newConfig;
	};

	const is_token_expired = (token) => {
		var current_time = new Date().getTime() / 1000;
		var jwt = jwt_decode(token);
		return current_time > jwt.exp;
	};

	return props.children;
};

export default SetupAxios;
